import React, { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { getUserPermissions, profile } from '../../services/vehicles';
import Header from '../../modules/Header/Header';
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { setPermissions, setSessionExpired, setUser } from '../../redux/slices/userSlice';
import SessionExpireDialog from './SessionExpireDialog';
import { GLOBAL_USER } from '../../utils/constants';

const DashboardLayout = () => {
  // use hooks
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();

  // global states
  const { sessionExpired } = useAppSelector((state) => state.user);

  useEffect(() => {
    getUserPermissions({ query: GLOBAL_USER })
      .then((res) => {
        dispatch(setPermissions(res));
        setLoading(false);
      })
      .catch(() => console.error('error fetching permissions'));
  }, []);

  // handling initial load
  const fetchRecords = useCallback(async () => {
    try {
      const resp = await profile({ method: 'GET' });
      dispatch(setUser(resp?.data?.data));
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  // // lifecycle hook
  // useEffect(() => {
  //   fetchRecords();
  // }, [fetchRecords]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Header />
      <Outlet />
      <SessionExpireDialog open={sessionExpired} onClose={() => dispatch(setSessionExpired(false))} />
    </>
  );
};

export default DashboardLayout;
